<template>
  <h1>RFID Actions</h1>
  <div id="page-rfid-dashboard" class="content-section">
    <div class="page-section">

      <div class="content-section">
        <div class="row">
          <div class="col-lg-3 col-md-4" >
            <div>
              <FormKit
                  type="button"
                  label="Associate Tags"
                  input-class="$reset btn-rfid-lg btn btn-rfid btn-associate"
                  @click="goTo('AssociateTags')"
              />
            </div>
            <div>
              <FormKit
                  type="button"
                  label="Association Logs"
                  input-class="$reset btn-rfid-sm btn btn-rfid btn-associate"
                  @click="goTo('AssociationLogs')"
              />
            </div>
          </div>

          <div class="col-lg-3 col-md-4">
            <div>
              <FormKit
                  type="button"
                  label="Process"
                  input-class="$reset btn-rfid-lg btn btn-rfid btn-process"
                  @click="goTo('Process')"
              />
            </div>
            <div>
              <FormKit
                  type="button"
                  label="Process Logs"
                  input-class="$reset btn-rfid-sm btn btn-rfid btn-process"
                  @click="goTo('ProcessLogs')"
              />
            </div>
          </div>

          <div class="col-md-3">
            <div>
              <FormKit
                  type="button"
                  label="Rogues'Gallery"
                  input-class="$reset btn-rfid-lg btn btn-rfid btn-rogues"
                  @click="goTo('RogueGallery')"
              />
            </div>
          </div>
          

          <div class="col-md-3">
            <div>
              <FormKit
                  type="button"
                  label="Folding"
                  input-class="$reset btn-rfid-lg btn btn-rfid btn-bundling"
                  @click="goTo('FoldingTicket')"
              />
            </div>
          </div>

         
        </div>
      </div>


      <div class="clearfix"></div>
      <div class="content-section mt-4">
        <div class="row ">
          <div class="col-md-3">
            <div>
              <FormKit
                  type="button"
                  label="Bedding PU"
                  input-class="$reset btn-rfid-lg btn btn-rfid btn-pieceup"
                  @click="goTo('PieceUp')"
              />
            </div>
          </div>

          <!--<div class="col-md-3">
            <div>
              <FormKit
                  type="button"
                  label="Q-PUP"
                  input-class="$reset btn-rfid-lg btn btn-rfid btn-qpup"
                  @click="goTo('Q-PUP')"
              />
            </div>
          </div>-->
        </div>
      </div>

      


    </div>
  </div>
</template>


<script setup>

import {onMounted, ref, inject, reactive} from 'vue'
import 'bootstrap/dist/css/bootstrap.min.css';

const goTo = (pageSection) =>   {
  switch (pageSection) {
    case "AssociateTags":
      window.open(
          "/rfid/associate-tag",
          "_self"
      );
      break;
    case "AssociationLogs":
      window.open(
          "/rfid/association-logs",
          "_self"
      );
      break;
    case "Process":
      window.open(
          "/rfid/processing-selection",
          "_self"
      );
      break;
    case "ProcessLogs":
      alert('ProcessLogs regirect');
      break;
    case "FoldingTicket":
      window.open(
          "/rfid/folding-ticket",
          "_self"
      );
      break;
    case "PieceUp":
      window.open(
          "/rfid/pieceup",
          "_self"
      );
      break;
  case "PieceUpLogs":
      window.open(
          "/rfid/pieceup-logs",
          "_self"
      );
      break;
  case "RogueGallery":
      window.open(
          "/rfid/rogue-gallery",
          "_self"
      );
      break;
    case "Q-PUP":
      window.open(
          "/qpup/q-pup",
          "_self"
      );
      break;
    default:
      console.error("Unknown page section: " + pageSection);
      break;
  }
}

</script>


<style scoped>

</style>
